import { Table, Text } from '@timelyapp/react';
import type { TagStructure } from 'components/datatable/datatable.types';
import React, { type ReactNode } from 'react';
import type { ColumnModeOptions } from 'redux/modules/accounts.types';
import styles from './ExampleTagsTable.module.scss';

const Tag: React.FC<{ children: ReactNode }> = ({ children }) => (
  <span className={styles.tag}>
    <Text.Label size="xsmall">{children}</Text.Label>
  </span>
);

interface Props {
  tagsMode: ColumnModeOptions;
  tagsStructure: TagStructure;
}

const ExampleTagsTable: React.FC<Props> = ({ tagsMode, tagsStructure }) => {
  if (tagsStructure === 'consolidated') {
    if (tagsMode === 'all') {
      return (
        <Table className={styles.table}>
          <Table.Thead className={styles.thead}>
            <Table.Th>Tags</Table.Th>
          </Table.Thead>
          <Table.Tbody className={styles.tbody}>
            <Table.Tr>
              <Table.Td>
                Pet; <Tag>🐈 Cat</Tag>
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                Tree; <Tag>🌲 Pine</Tag>
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                Pet; <Tag>🐕 Dog</Tag> Tree; <Tag>🌳 Birch</Tag>
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      );
    } else if (tagsMode === 'parent_tags') {
      return (
        <Table className={styles.table}>
          <Table.Thead className={styles.thead}>
            <Table.Th>Tags</Table.Th>
          </Table.Thead>
          <Table.Tbody className={styles.tbody}>
            <Table.Tr>
              <Table.Td>Pet</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Tree</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Pet, Tree</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      );
    } else if (tagsMode === 'tags') {
      return (
        <Table className={styles.table}>
          <Table.Thead className={styles.thead}>
            <Table.Th>Tags</Table.Th>
          </Table.Thead>
          <Table.Tbody className={styles.tbody}>
            <Table.Tr>
              <Table.Td>
                <Tag>🐈 Cat</Tag>
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                <Tag>🌲 Pine</Tag>
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                <Tag>🐕 Dog</Tag>&nbsp;
                <Tag>🌳 Birch</Tag>
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      );
    }
  } else {
    return (
      <Table className={styles.table}>
        <Table.Thead className={styles.thead}>
          <Table.Th>Pet</Table.Th>
          <Table.Th>Tree</Table.Th>
        </Table.Thead>
        <Table.Tbody className={styles.tbody}>
          <Table.Tr>
            <Table.Td>
              <Tag>🐈 Cat</Tag>
            </Table.Td>
            <Table.Td></Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td></Table.Td>
            <Table.Td>
              <Tag>🌲 Pine</Tag>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <Tag>🐕 Dog</Tag>
            </Table.Td>
            <Table.Td>
              <Tag>🌳 Birch</Tag>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    );
  }
  return null;
};

export default ExampleTagsTable;
